import {
  FeatureMode,
  FeatureRuleCountDto,
  FeatureRuleType,
} from '@vs/rtk/slices/apiDmAdmin';
import { DeployEnv } from '@vs/utils/envConfig';

export const FEATURE_KEY_RE = /^feature_[a-z0-9_]+$/;

// Region 對 entity.area，寫死四個值（SelectorVsRegion 的值對不上 area）
export const REGIONS = ['VSI', 'VSA', 'TW', 'VSE'] as const;

/** Feature Access 的分頁（location.hash） */
export const FeatureTab = {
  features: 'features',
  groups: 'groups',
} as const;

export const RULE_TYPES: FeatureRuleType[] = [
  'entity',
  'country',
  'region',
  'group',
];

export const RULE_TYPE_LABEL: Record<FeatureRuleType, string> = {
  entity: 'Entity',
  country: 'Country',
  region: 'Region',
  group: 'Group',
};

/** 數量加上單複數正確的名詞，例如 1 entity／2 entities */
export function countOf(n: number, [one, many]: readonly [string, string]) {
  return `${n} ${n === 1 ? one : many}`;
}

export const ENTITY_NOUN = ['entity', 'entities'] as const;

/** 四種規則的總數 */
export const sumRuleCount = (count: FeatureRuleCountDto) =>
  count.entity + count.country + count.region + count.group;

export const MODE_LABEL: Record<FeatureMode, string> = {
  all: 'All entities',
  restricted: 'Only listed below',
  none: 'No entities',
};

/** 生效時間 = dm-permission 的快照週期：prod 1 小時，其他 5 分鐘（rc 沒有 vs-admin） */
export function getEffectiveDelayText(env: DeployEnv) {
  return env === 'prod' ? '1 hour' : '5 minutes';
}

/** 強確認（輸入 key）只在 prod */
export function requiresKeyConfirm(env: DeployEnv) {
  return env === 'prod';
}
